import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createToken } from "@/lib/api/tokens";
import { toast } from "sonner";
import { getErrorMessage } from "@/utils/errorMessages";
import type { CreateTokenRequest } from "@/types/token";

export function useCreateToken() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateTokenRequest) => createToken(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["tokens"] });
      toast.success("Token created successfully");
    },
    onError: (error: Error) => {
      const message = getErrorMessage(error);
      toast.error(message);
    },
  });
}
